import { useState } from "react";
import _ from 'lodash';

import { useAppContext } from "../../context";
import { notify } from "../../utils";
import { IMenuApps, IMenuApp, MenuAppType, IUser } from "../../globals/interfaces";
import { HandleCreateUpdate, CreateUpdate, Delete } from "./interfaces";
import useAppData from "../../customHooks/useAppData";
import apiClient from "../../apiClient";

export interface MenuAppsData {
    user: IUser;
    appDataLoaded: boolean;
    menuApps: IMenuApps;
    handleCreateUpdate: HandleCreateUpdate;
    modalManageMenu: boolean;
    setModalManageMenu: React.Dispatch<React.SetStateAction<boolean>>;
    indexNum: number;
    selectedType: MenuAppType;
    selectedItem: IMenuApp | undefined;
    createUpdateMenuItem: CreateUpdate,
    deleteMenuItem: Delete
}

export default function useMenuAppsData (): MenuAppsData {
    const {
        user
    } = useAppContext();
    const { menuApps, setAppData, appDataLoaded } = useAppData();
    const [selectedItem, setSelectedItem] = useState<IMenuApp>();
    const [selectedType, setSelectedType] = useState<MenuAppType>('USER');
    const [indexNum, setIndexNum] = useState<number>(0);
    const [modalManageMenu, setModalManageMenu] = useState(false);

    const handleCreateUpdate: HandleCreateUpdate = (
        indexNum: number,
        type: MenuAppType,
        selectedItem?: IMenuApp
    ) => {
        if (selectedItem) {
            setSelectedItem(selectedItem);
        } else {
            setSelectedItem(undefined);
        }
        setSelectedType(type);
        setIndexNum(indexNum);
        setModalManageMenu(true);
    };

    const createUpdateMenuItem: CreateUpdate = async (data: IMenuApp, update: boolean) => {
        const method = update ? 'put' : 'post';
        const res = await apiClient[method]('/menuApp', data);
        if ([200, 204].includes(res.status)) {
            setAppData(prev => {
                const copy = _.cloneDeep(prev);
                const updateApps =
                    data.type === 'SYSTEM' ? copy.menuApps.system : copy.menuApps.user;
                if (update) {
                    const updateIndex = updateApps.findIndex(
                        (app) => app.id === data.id
                    );
                    updateApps[updateIndex] = res.data;
                } else {
                    updateApps.push(res.data);
                }
                return copy;
            });
            setModalManageMenu(false);
            notify('Success');
        }
    };

    const deleteMenuItem: Delete = async (id: number, type: MenuAppType) => {
        const res = await apiClient.delete(`/menuApp/${id}`);
        if (res.status === 204) {
            setAppData((prev) => {
                const copy = _.cloneDeep(prev);
                // @ts-ignore
                const updateApps: Array<IMenuApp> = copy.menuApps[type.toLowerCase()];
                const filtered = updateApps.filter(app => app.id !== id);
                // @ts-ignore
                copy.menuApps[type.toLowerCase()] = filtered;
                return copy;
            });
            setModalManageMenu(false);
            notify('Success');
        }
    };

    return {
        user,
        appDataLoaded,
        menuApps, 
        handleCreateUpdate,
        modalManageMenu,
        setModalManageMenu,
        indexNum,
        selectedType,
        selectedItem,
        createUpdateMenuItem,
        deleteMenuItem
    }
}